import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    //获取续费信息列表
    GET_RENEW_LIST(data) {
        controller='PlatRenew';
        action='GetList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //新增续费信息
    ADD_RENEW(data) {
        controller='PlatRenew';
        action='AddRenew';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //查看平台设置续费信息列表
    GET_RENEW_SETTING_LIST(data) {
        controller='PlatRenew';
        action='GetRenewSettingList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //新增续费设置信息
    ADD_RENEW_SETTING(data) {
        controller='PlatRenew';
        action='AddRenewSetting';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //删除续费设置信息
    DEL_RENEW_SETTING(data) {
        controller='PlatRenew';
        action='DelRenewSetting';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改续费设置停用
    RENEW_SETTING_ISSTOP(data) {
        controller='PlatRenew';
        action='ChangeRenewStop';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取续费设置信息详情
    GET_RENEW_SETTING_INFO(data) {
        controller='PlatRenew';
        action='GetRenewSettingInfo';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //编辑续费设置信息
    EDIT_RENEW_SETTING(data) {
        controller='PlatRenew';
        action='EditRenewSetting';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //同步微信虚拟支付道具
    SYNC_VIRTUAL_GOODS(data) {
        controller='PlatRenew';
        action='SyncVirtualGoods';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}